import { EmeetServices } from "../keys/props/services"

export const version = 'v4.2.023'
export const minutesToExpire = 720
export const DDInviteLinkExpire = 12 * 60
export const maxCreditForMalaysiaBuddy = 30.00
export const servicesThatRequiresNonTexting = [
    EmeetServices.karaoke,
    EmeetServices.asmr,
    EmeetServices.wakeupcall,
    EmeetServices.sleepcall,
    EmeetServices.drawing,
    EmeetServices.langexchange,
    EmeetServices.upbeatconversation,
    EmeetServices.fortunetelling,
    EmeetServices.offmychest
]